module.exports = __webpack_public_path__ + "static/media/grandUnion.49bcf65f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/grandUnion.jpg
// module id = 311
// module chunks = 0